<template>
<div class="home">
    <Snack :active="activeSnack" :duration="5000" :msg="msgSnack" @deactivate="activeSnack = false" :color="color" />
    <div v-if="operation == 'login'" class="login-card">
        <div class="input-container">
            <label for="user">Email </label>
            <input id="user" type="email" v-model="username" />
        </div>
        <div v-if="hiddenPassword" class="input-container">
            <label class="label" for="pwd">Password </label>
            <input id="pwd" type="password" v-model="password" />
            <svg v-if="password.length > 0" @click="hiddenPassword = false" height="24" viewBox="0 0 24 24" width="24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" /></svg>
        </div>
        <div class="input-container" v-else>
            <label class="label" for="pwd">Password </label>
            <input id="pwd" type="text" v-model="password" />
            <svg @click="hiddenPassword = true" height="24" viewBox="0 0 24 24" width="24">
                <path d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z" fill="none" />
                <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" /></svg>
        </div>
        <Button style="margin-top: 50px" @click.native="login" :msg="'Login'" />

        <span class="recovery" @click="operation = 'forgotPassword'">Password dimenticata?</span>
    </div>
    <div v-else-if="operation == 'firstAccess'" class="login-card">
        <div class="text">
            <span style="font-family: arial">Hai effettuato l'accesso con una password temporanea, inserisci una nuova password con i seguenti requisiti:</span>
            <ul style="font-family: arial">
                <li>Minimo 6 charatteri</li>
                <li>Un carattere minuscolo</li>
                <li>Un carattere maiuscolo</li>
                <li>Un carattere speciale es. (?, !, @)</li>
            </ul><br>
        </div>
        <label class="label" for="pwd" style="margin-top: -10px">Nuova password </label>
        <input id="pwd" type="password" v-model="newPwd" />
        <label class="label" for="pwdConf">Conferma password </label>
        <input id="pwdConf" type="password" v-model="newPwdConf" />
        <Button style="margin-top: 20px" @click.native="handleNewPassword" :msg="'Conferma'" />
    </div>
    <div v-else-if="operation == 'forgotPassword'" class="login-card">
        <div class="text">
            <span style="font-family: arial">Inserisci mail</span>
        </div>
        <label class="label" for="pwdConf">Email </label>
        <input id="pwdConf" type="email" v-model="username" />
        <Button style="margin-top: 20px" @click.native="changePassword" :msg="'Recupera password'" />
    </div>
    <div v-else-if="operation == 'newPassword'" class="login-card">
        <div class="text">
            <span style="font-family: arial">Ti è stato inviato un codice alla mail indicata:</span>
        </div>
        <label class="label" for="pwdConf">Codice </label>
        <input id="pwdConf" type="text" v-model="code" />

        <label class="label" for="pwdConf">Nuova Password </label>
        <input id="pwdConf" type="password" v-model="newPassword" />
        <Button style="margin-top: 20px" @click.native="setNewPassword" :msg="'Conferma'" />
    </div>
</div>
</template>

<script>
//import 'cross-fetch/polyfill';
import Button from '@/components/Button'
import Snack from '@/components/Snack'
var AmazonCognitoIdentity = require('amazon-cognito-identity-js');

export default {
    name: 'home',
    components: {
        Button,
        Snack
    },
    data() {
        return {
            username: '',
            password: '',
            sessionUserAttributes: {},
            setNewPwd: false,
            newPwd: '',
            newPwdConf: '',
            cognitoUser: '',
            hiddenPassword: true,
            activeSnack: false,
            msgSnack: '',
            operation: 'login',
            poolData: {
                UserPoolId: 'eu-central-1_ewbMPQcIH', // Your user pool id here
                ClientId: '1j8i43hpt7uf00h7onr567o369', // Your client id here
            },
            newPassword: '',
            code: '',
            color: ''
        }
    },
    methods: {
        handleNewPassword() {
            if (this.newPwd != this.newPwdConf) {
                this.activeSnack = true;
                this.msgSnack = 'Le password non coincidono';
            } else {
                var that = this;
                this.cognitoUser.completeNewPasswordChallenge(this.newPwd, this.sessionUserAttributes, {
                    onSuccess: result => {
                        var accessToken = result.getAccessToken().getJwtToken();
                        that.$store.commit('setAuth', accessToken);

                        that.cognitoUser.getUserAttributes(function (err, result) {
                            if (err) {
                                alert(err.message || JSON.stringify(err));
                                return;
                            }

                            //const company = result.filter(attr => attr.CognitoUserAttribute.Name !== 'custom:company')[0].CognitoUserAttribute.Value

                            const company = result.filter(attr => {
                                return attr.Name == 'custom:company'
                            })

                            window.localStorage.setItem('company', company[0].Value);


                            that.$router.push('home')

                            console.log(company)
                        });
                    },
                    onFailure: err => {
                        that.color = 'red';
                        that.activeSnack = true;
                        console.log(err.message || JSON.stringify(err))
                        that.msgSnack = 'Errore';
                    }
                });
            }

        },
        login() {
            var authenticationData = {
                Username: this.username,
                Password: this.password,
            };

            var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
                authenticationData
            );

            var userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
            var userData = {
                Username: this.username,
                Pool: userPool,
            };
            this.cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
            var that = this;
            this.cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: function (result) {
                    var accessToken = result.getAccessToken().getJwtToken();
                    that.$store.commit('setAuth', accessToken);
                    that.$store.commit('setUsername', that.username);

                    that.cognitoUser.getUserAttributes(function (err, result) {
                        if (err) {
                            alert(err.message || JSON.stringify(err));
                            return;
                        }

                        const company = result.filter(attr => {
                            return attr.Name == 'custom:company'
                        })

                        window.localStorage.setItem('company', company[0].Value);

                        that.$router.push({
                            path: '/home'
                        })
                    });
                },

                onFailure: function (err) {
                    that.color = 'red';
                    that.activeSnack = true;
                    console.log(err.message || JSON.stringify(err));
                    that.msgSnack = 'Errore';
                },

                newPasswordRequired(userAttributes) {
                    delete userAttributes.email_verified;

                    that.sessionUserAttributes = userAttributes;

                    that.operation = 'firstAccess';
                },

            });
        },

        changePassword() {
            var that = this;

            var userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
            var userData = {
                Username: this.username,
                Pool: userPool,
            };
            this.cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

            this.cognitoUser.forgotPassword({
                onSuccess: function (data) {
                    // successfully initiated reset password request
                    that.operation = 'newPassword'
                    console.log('CodeDeliveryData from forgotPassword: ' + data);
                },
                onFailure: function (err) {
                    that.color = 'red';
                    that.activeSnack = true;
                    console.log(err.msg || JSON.stringify(err))
                    that.msgSnack = 'Errore';
                },
            });
        },

        setNewPassword() {
            var that = this;
            this.cognitoUser.confirmPassword(this.code, this.newPassword, {
                onSuccess() {
                    console.log('Password confirmed!');
                    that.color = 'success';
                    that.activeSnack = true;
                    that.msgSnack = 'Password cambiata con successo';
                    that.operation = 'login';
                },
                onFailure(err) {
                    that.color = 'error';
                    that.activeSnack = true;
                    that.msgSnack = 'Errore';
                },
            });
        }

    },
}
</script>

<style lang="scss" scoped>
.text {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    color: #C5281C;
    margin-top: -30px;
}

.home {
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
}

.input-container {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.login-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px solid grey;
    height: 450px;
    width: 20%;
    min-width: 370px;
    align-items: center;
    margin-top: 100px;
    padding-top: 50px;
}

.label {
    margin-top: 20px;
}

.btn-login {
    margin-top: 50px;
}

label {
    margin-bottom: 10px;
    font-family: arial;
}

input[type=email],
input[type=password],
input[type=text] {
    padding: 20px;
    background-color: whitesmoke;
    border: none;
    border-bottom: 2px solid #C5281C;
    width: 260px;

    &:focus {
        outline: none;
        border-bottom: 2px solid #42a5f5;
    }
}

svg {
    position: absolute;
    top: 65px;
    right: 40px;
    cursor: pointer;
}

.recovery {
    margin-top: 50px;
    font-family: arial;
    color: #C5281C;
    text-decoration: underline;
    cursor: pointer;
}
</style>
